module.exports = __webpack_public_path__ + "img/05.40a2f25a.png";